import { useQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { CommunicationFacilitiesQueryVariables } from "generated-graphql/graphql";

export const COMMUNICATION_FACILITIES_QUERY = gql(`
  query CommunicationFacilities($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    facilities(search:$search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        name
        customerFacilityId
        lepcId
        lepc {
            name
        }
        fireDepartmentId
        fireDepartment {
            name
        }
        streetAddress1
        city
        state
        zip
      }
      count
    }
  }
`);

export function useCommunicationFacilities({
  facilityIds,
  ...variables
}: { facilityIds?: string[] } & CommunicationFacilitiesQueryVariables) {
  return useQuery(COMMUNICATION_FACILITIES_QUERY, {
    variables: {
      ...variables,
      search: facilityIds && `id:${facilityIds.join("|")}`,
    },
    skip: !facilityIds?.length,
  });
}
